import React from "react";
import { Box, Button, Stack, Typography } from "digiwash-components";
import useToast from "./useToast";

interface ToastMessageType {
  message: string | React.ReactNode;
  options?: {
    actionText?: string;
    action?: () => void;
    type?: string;
    showDismiss?: boolean;
  };
}

function ToastMessage(props: ToastMessageType) {
  let bg = "common.white";
  let TextColor = "common.black";
  if (props.options) {
    if (props.options.type === "success") {
      bg = "green.main";
      TextColor = "common.white";
    } else if (props.options.type === "danger") {
      bg = "red.light200";
      TextColor = "common.white";
    } else if (props.options.type === "warning") {
      bg = "orange.dark";
      TextColor = "common.white";
    }
  }
  let toast = useToast();
  return (
    <Box style={{ width: "100%", maxWidth: 468 }} p="l">
      <Box br="xm" bg={bg} p="l">
        <Stack>
          <Typography color={TextColor}>{props.message}</Typography>
          {props.options && props.options.actionText ? (
            <Stack>
              <Button
                onPress={() => {
                  toast.hideAll();
                }}
                fill="transparent"
                textColor="gray.light960"
              >
                بیخیال
              </Button>
              <Button
                onPress={props.options.action}
                fill="transparent"
                textColor="primary.main"
              >
                {props.options.actionText}
              </Button>
            </Stack>
          ) : null}
        </Stack>
      </Box>
    </Box>
  );
}

export default ToastMessage;
